// extracted by mini-css-extract-plugin
export default {"input":"ProcessingTime_input__VGBQf","text":"ProcessingTime_text__oNWC5","autocomplete":"ProcessingTime_autocomplete__PsqMt"};